document.querySelectorAll('.help__category-questionCat').forEach(function(cat) {
	cat.addEventListener('click', function() {
		cat.closest('.help__category-questionBlock').classList.toggle('is-open');
	});
});
